<!-- 级联 -->
<template>
    <div>
        <input :value="selectedText"
               readonly
               placeholder="请选择"
               type="text"
               @click="visible = true"
        />
        <checklist
            v-if="dataList.length > 0 && flagPreData"
            :key="key"
            v-model="visible"
            :data="dataList"
            :selects="selectedItems"
            v-bind="$attrs"
            @on-close="visible = false"
            @on-confirm="confirm"
        />
    </div>
</template>
<script>
import { Checklist } from '@58fe/v5';
import cookie from '@/utils/cookie';
import { getParamVal } from '@/utils/tools';

export default {
    components: { Checklist },
    props: {
        type: {
            type: String,
            default: ''
        },
        value: {
            type: String,
            default: ''
        },
        topArea: {
            type: String,
            default: ''
        },
        flagPreData: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            visible: false,
            dataList: [],
            key: 1,
            selectedItems: [], // 选中的职位
            selectedText: '', // 选中职位名字拼接
            selectedIds: '', // 选中职位id拼接
            hasSelected: false
        };
    },
    computed: {},
    watch: {
        selectedItems(v) {
            this.selectedText = '';
            this.selectedIds = '';
            v.forEach((item, i) => {
                if (i > 0) {
                    this.selectedText += '/';
                    this.selectedIds += ',';
                }
                this.selectedText += item.name;
                this.selectedIds += item.id;
            });
            this.$emit('input', this.selectedIds);
        },
        value() {
            this.init();
        },
        dataList() {
            this.init();
        },
        flagPreData(v) {
            if (v && this.type === 'city') {
                this.getAreaInfo();
            }
        }
    },
    created() {
        if (this.type !== 'city') {
            this.getTargetCateIDs();
        }
    },
    methods: {
        confirm(val) {
            this.selectedItems = val;
            this.visible = false;
        },
        init() {
            if (this.value && this.dataList.length && !this.selectedItems.length) {
                const ids = this.value.split(',').map((id) => (Number(id)));
                const selects = [];
                this.dataList[1].forEach((e) => {
                    e.list.forEach((ei) => {
                        if (ids.includes(ei.id)) {
                            selects.push(ei);
                        }
                    });
                });
                this.selectedItems = selects;
            }
        },
        async getAreaInfo() {
            const { object: payload } = await this.$api.getAreaInfo({cityname: this.topArea || getParamVal('topArea') || cookie.get('mcity')});
            const secondarea = payload.secondarea;
            const thridarea = payload.thridarea;
            // 一级城市全部的子元素
            const item = { parentId: secondarea[0].id, list: [secondarea[0]] };
            thridarea.unshift(item);
            this.dataList = [secondarea, thridarea];
            this.key ++;
        },
        async getTargetCateIDs() {
            const data = await this.$api.getTargetCateIDs();
            const list0 = [];
            const list1 = [];
            (data || []).forEach((item) => {
                list0.push({
                    id: item.id,
                    name: item.name
                });
                if (Array.isArray(item.subList) && item.subList.length > 0) {
                    const subList = [];
                    item.subList.forEach((sub, index) => {
                        subList.push({
                            id: sub.DispCategoryID,
                            name: sub.CateName
                        });
                        if (index === item.subList.length - 1) {
                            list1.push({
                                parentId: item.id,
                                list: subList
                            });
                        }
                    });
                }
            });
            const list = [list0, list1];
            this.dataList = list;
            this.key ++;
        }
    }
};
</script>
